import { Link } from "react-router-dom";
import { Hourglass } from "lucide-react";

export default function PendingApproval() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-[#F9F8F6]">
      <div className="max-w-md w-full text-center bg-white border border-[#E5E2DC] p-10">
        <div className="h-14 w-14 bg-[#F0EFEA] mx-auto flex items-center justify-center">
          <Hourglass className="h-6 w-6 text-[#C06C47]" />
        </div>
        <h1 className="font-heading text-2xl mt-6" data-testid="pending-title">Awaiting Admin Approval</h1>
        <p className="text-sm text-[#5C6653] mt-3">
          Thank you for registering. Your account is currently under review. You will be able to log in once your account is approved by an authorized administrator.
        </p>
        <Link
          to="/login"
          data-testid="pending-goto-login"
          className="mt-8 inline-flex items-center justify-center px-5 py-2.5 text-sm bg-[#234B36] hover:bg-[#1A3A29] text-white transition-colors"
        >
          Back to Sign In
        </Link>
      </div>
    </div>
  );
}
